import AxiosInstance from "../config/AxiosInstance";

export const getCompanies = async () => {
    try {
        const { data } = await AxiosInstance.get('/api/companies');
        return { data };
    } catch (error) {
        throw error;
    }
};

export const getDetailCompanies = async (companyId: string) => {
    try {
        const { data } = await AxiosInstance.get('/api/companies/' + companyId);
        return { data };
    } catch (error) {
        throw error;
    }
};

export const updateDetialCompanies = async (company_id: any, payload: any) => {
    try {
        const { data } = await AxiosInstance.put('/api/companies/update/' + company_id, payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

export const sentInviteAccountant = async (payload: any) => {
    try {
        const { data } = await AxiosInstance.post('/api/users/inviteCompanyAccountant', payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

export const removeInviteAccountant = async (payload: any) => {
    try {
        const { data } = await AxiosInstance.post('/api/users/removeCompanyAccountant', payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

export const createNewUser = async (payload: any) => {
    try {
        const { data } = await AxiosInstance.post('/api/companies/createNewUser', payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

export const updatreNewUser = async (companyId: string, id: string, payload: any) => {
    try {
        const { data } = await AxiosInstance.put('/api/companies/updateUserCompany/' + companyId + "/" + id, payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

export const getUser = async (companyId: any, page: any, limit: any,) => {
    try {
        const { data } = await AxiosInstance.get('/api/companies/listUserForCompany/' + companyId + '/' + page + '/' + limit);
        return { data };
    } catch (error) {
        throw error;
    }
};

export const getDetailUser = async (companyId: string, userId: string) => {
    try {
        const { data } = await AxiosInstance.get('/api/companies/findUserForCompany/' + companyId + '/' + userId);
        return { data };
    } catch (error) {
        throw error;
    }
};
export const resetPasword = async (payload: any) => {
    try {
        const { data } = await AxiosInstance.post('/api/auth/reset-password', payload);
        return { data };
    } catch (error) {
        throw error;
    }
};
export const deleteUserCompany = async (companyId: string, userId: string) => {
    try {
        const { data } = await AxiosInstance.delete('/api/companies/deleteUserCompany/' + companyId + '/' + userId);
        return { data };
    } catch (error) {
        throw error;
    }
};
